import { Command } from '../../_base/actionBus/Command';

export class ChangePassword extends Command {
    constructor(public validationCode: string, public email: string, public password: string, public confirmationPassword: string) {
        super();
    }
}
